import classnames from 'classnames';
import { RightOutlined } from '@ant-design/icons';
import classes from './index.module.scss';

import { Button } from '..';
import type { ButtonProps } from 'antd';

interface IMoreButtonProps extends Omit<ButtonProps, 'icon' | 'type'> {
  className?: string;
}

const MoreButton = (props: IMoreButtonProps) => {
  const { className, size = 'small', children = '更多', onClick, ...rest } = props;
  const handleClick = () => {
    if (onClick) {
      onClick(); // 触发传入的点击事件处理函数
    }
  };
  return (
    <Button
      className={classnames(classes.wrap, className)}
      size={size}
      type="text"
      {...rest}
      onClick={handleClick}>
      {children}
      <RightOutlined className={classes.icon} />
    </Button>
  );
};

export default MoreButton;
